/* eslint-disable no-restricted-syntax */
import React, { Component } from "react";
import PropTypes from "prop-types";
import Fade from "reactstrap/lib/Fade";

import { gatherClasses, isFunction } from "../../lib/utils";
import ToastContainer from "./toastContainer";

class Toast extends Component {
  constructor(props) {
    super(props);
    this.timers = {};
  }

  componentWillUnmount() {
    this.clearAllTimers();
  }

  onAlertClose = (alert, timer) => {
    const { onClose } = this.props;
    clearTimeout(timer);
    delete this.timers[timer];

    if (isFunction(onClose)) {
      onClose(alert);
    }
  };

  getTimer = alert => {
    // eslint-disable-next-line no-restricted-syntax
    for (const timer in this.timers) {
      if (this.timers[timer] === alert) {
        return timer;
      }
    }
    return null;
  };

  registerTimer = alert => {
    const { delay } = this.props;
    /*
      render() will call this method multiple times,
      so if a timer is already registered for an alert
      then a new timer should not be registered for the same alert
      instead we should use the existing.
      Otherwise go ahead and create a new timer.
    */
    const prevTimer = this.getTimer(alert);
    if (prevTimer) {
      return prevTimer;
    }

    const timer = setTimeout(() => {
      this.onAlertClose(alert, timer);
    }, delay);
    this.timers[timer] = alert;
    return timer;
  };

  clearAllTimers = () => {
    // eslint-disable-next-line guard-for-in
    for (const timer in this.timers) {
      clearTimeout(timer);
    }
    this.timers = {};
  };

  getAlertCode = (alert, index) => {
    const timer = this.registerTimer(alert);
    return (
      <Fade in key={index}>
        <div
          className={`oui-alert oui-alert-${alert.type} oui-alert-dismissible oui-fade oui-show`}
          role="alert"
        >
          <button
            type="button"
            className="oui-close"
            aria-label="Close"
            onClick={() => {
              this.onAlertClose(alert, timer);
            }}
          >
            <span aria-hidden="true">&times;</span>
          </button>
          {alert.message}
        </div>
      </Fade>
    );
  };

  render() {
    const { dataTestId, alerts } = this.props;
    return (
      <ToastContainer
        dataTestId={dataTestId}
        className={gatherClasses(this.props)}
      >
        {alerts.map((alert, index) => {
          return this.getAlertCode(alert, index);
        })}
      </ToastContainer>
    );
  }
}

Toast.propTypes = {
  delay: PropTypes.number,
  alerts: PropTypes.arrayOf(
    PropTypes.shape({
      message: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
        .isRequired,
      type: PropTypes.oneOf(["success", "warning", "danger", "info"])
    })
  ).isRequired,
  onClose: PropTypes.func.isRequired,
  dataTestId: PropTypes.string
};

Toast.defaultProps = {
  // eslint-disable-next-line react/default-props-match-prop-types
  alerts: [],
  delay: 5000,
  dataTestId: "orion-toast"
};

Toast.displayName = "OrionToast";

export default Toast;
